<!-- <template>
    <div>
  <PostEditPage view="Post" />
    </div>

</template>

<script>
import PostEditPage from "./PostEditPage.vue";
export default { components: { PostEditPage } };
</script> -->




<template>
   <PostEditPage
    view="Post"
  />
  <AuthModal
    v-if="!isCheckingAuth && !isValidToken"
    :mode="authMode"
    @close="redirectBack"
    @switchMode="authMode = $event"
  />

 
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import AuthModal from "./Models/AuthModal.vue";
import PostEditPage from "./PostEditPage.vue";

const isValidToken = ref(false);
const isCheckingAuth = ref(true);
const authMode = ref("login");
const router = useRouter();

// const redirectBack = () => {
//   router.push("/");
// };
const redirectBack = () => {
  router.push('/new-post'); // ✅ Vue-friendly navigation
};

onMounted(async () => {
  const token = localStorage.getItem("auth-token");

  if (!token) {
    isCheckingAuth.value = false;
    return;
  }

  try {
    await axios.post(
      "/api/verify-token",
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      }
    );
    isValidToken.value = true;
  } catch {
    isValidToken.value = false;
  } finally {
    isCheckingAuth.value = false;
  }
});
</script> 
